export function quotationPositions(quotation) {
  return (
    [
      ...new Set(
        (quotation.products || []).map((item) => item.poste).filter(Boolean),
      ),
    ].join(" · ") ||
    quotation.qualification ||
    "—"
  );
}
export function quotationServices(quotation) {
  const labels = (quotation.products || [])
    .map((item) => {
      const value =
        item.contractType || item.service || item.type || item.product;
      const normalized = String(value || "")
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "")
        .toLowerCase()
        .trim();
      return (
        {
          delegation: "Intérim",
          gestion: "Intérim",
          interim: "Intérim",
          cdd: "CDD",
          cdi: "CDI",
          vacation: "Vacation",
          placement: "Placement (type à préciser)",
        }[normalized] || value
      );
    })
    .filter(Boolean);
  return [...new Set(labels)].join(" · ") || "—";
}
